import React, { useMemo, useState } from "react";
import { Button, Icon, SystemMessage, Tooltip } from "@shoptet/ui";
import { useAdminIncreaseCreditMutation } from "../../graphql/generated/graphql";
import { formatCurrencyUnit } from "../../i18n/formatNumbers";
import { useAppSettings } from "../../providers/appSettingsProvider";
import { ModalWrapper } from "../ModalWrapper";
import NumberFieldWithUnit from "../NumberFieldWithUnit";

type CreditModalIncreasePropsT = {
  apiToken: string;
  onClose: () => void;
};
const CreditIncrease = ({ apiToken, onClose }: CreditModalIncreasePropsT) => {
  const { currency: defaultCurrency } = useAppSettings();
  const [increaseAmount, setIncreaseAmount] = useState("");

  const [state] = useState({
    currency: defaultCurrency,
    creditAmount: "2000",
  });
  const currency = state.currency;

  const [increaseCredit, { loading: loadingPayment }] = useAdminIncreaseCreditMutation({
    onCompleted() {
      onClose();
    },
  });

  const isFormValid = useMemo(() => increaseAmount && parseFloat(increaseAmount || "0") <= 0, [increaseAmount]);

  const handleChange = (value: number | null) => {
    setIncreaseAmount(value === null ? "" : value.toString());
  };

  const handleSend = () => {
    increaseCredit({
      context: {
        headers: {
          Authorization: `ApiToken ${apiToken}`,
        },
      },
      variables: {
        amount: parseFloat(increaseAmount || "0"),
        currency,
      },
    });
  };

  return (
    <div>
      <div style={{ marginTop: "1em", marginBottom: "4em", display: "flex" }}>
        <NumberFieldWithUnit
          label="Zadejte částku kreditu, kterou chcete navýšit jako demo peníze"
          min={0}
          name="credit_amount"
          unit={formatCurrencyUnit(currency)}
          value={increaseAmount === "" ? null : parseFloat(increaseAmount)}
          onChange={handleChange}
        />
      </div>
      {isFormValid && <SystemMessage description="Zadaná částka musí být větší jak 0." level="error" />}
      <Button disabled={!!isFormValid} variant={"action"} onClick={handleSend}>
        {loadingPayment ? "Loading" : "Přidat kredity"}
      </Button>
    </div>
  );
};

export const CreditModalIncrease = (props: { apiToken: string }) => {
  const [isOpen, setOpen] = useState(false);
  return (
    <>
      <Tooltip closeDelay={300} content="Dobit kredit">
        <span style={{ cursor: "pointer" }} onClick={() => setOpen(true)}>
          <Icon icon="shp-money" variant="secondary" />
        </span>
      </Tooltip>

      <ModalWrapper isOpen={isOpen} title="Increasse demo credits" onClose={() => setOpen(false)}>
        {isOpen && <CreditIncrease {...props} onClose={() => setOpen(false)} />}
      </ModalWrapper>
    </>
  );
};
